// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Np-z","imageAndVideoCount":"Op-z","imageAndVideoContainer":"Pp-z","viewAllReviews":"Qp-z"};